import { __require as require_baseProperty } from './_baseProperty.js';

var _asciiSize;
var hasRequired_asciiSize;

function require_asciiSize () {
	if (hasRequired_asciiSize) return _asciiSize;
	hasRequired_asciiSize = 1;
	var baseProperty = require_baseProperty();

	/**
	 * Gets the size of an ASCII `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	var asciiSize = baseProperty('length');

	_asciiSize = asciiSize;
	return _asciiSize;
}

export { require_asciiSize as __require };
//# sourceMappingURL=_asciiSize.js.map
